import { ensureCustomerAccess } from "./customerAccountAuthorize";
import { syncShopifyLiveCommerceCartNow } from "./syncCart";

import type { ShopifyCartLineInput } from "./syncCart";

type PreparedCheckout =
  /** この URL を、渡した窓で開く */
  | { kind: "url"; url: string }
  /** ログインはできたが、窓を使えない。もう一度「購入」を押してもらう */
  | { kind: "detached" }
  /** 購入をやめたとみなす（結果が届かなかった・中断された） */
  | { kind: "cancelled" };

/**
 * チェックアウトで開く URL を決める。
 *
 * 購入直前なので、認可できたかどうかにかかわらず同期し直した URL を返す。
 * 視聴中のイベントを注文に残すため、eventId は必ず付ける。
 * 認可できたら購入者と配送先も載る。認可できなければ載らないが、購入はできる。
 * 認可の途中で窓を閉じられたら、購入をやめたとみなして cancelled を返す。
 * 例外は投げない。同期できなければ、同期済みの URL で進める。
 */
export const prepareCheckoutUrl = async (input: {
  popup: Window;
  eventId: string;
  /**
   * 同期の直前に呼ぶ。認可の間も配信画面のカートは操作できるので、
   * 「購入」を押した時点の内容ではなく、そのときの最新の内容を同期する
   */
  getLines: () => ShopifyCartLineInput[];
  fallbackUrl: string;
  signal?: AbortSignal;
}): Promise<PreparedCheckout> => {
  try {
    const access = await ensureCustomerAccess(input.popup, input.signal).catch(
      (error: unknown) => {
        // 認可に失敗しても、イベントを残すために同期は続ける
        console.error(error);
        return "denied";
      }
    );
    if (access === "closed") return { kind: "cancelled" };
    // トークンは保存済み。次の「購入」で、そのクリックの中で開いた窓で同期して開く
    if (access === "detached") return { kind: "detached" };

    const cart = await syncShopifyLiveCommerceCartNow({
      eventId: input.eventId,
      lines: input.getLines(),
      attachEvent: true,
    });
    return { kind: "url", url: cart.checkoutUrl };
  } catch (error: unknown) {
    console.error(error);
    return { kind: "url", url: input.fallbackUrl };
  }
};
